import { withOneTrust } from '@segment/analytics-consent-wrapper-onetrust';
import { AnalyticsBrowser } from '@segment/analytics-next';

export const analytics = new AnalyticsBrowser();

if (typeof window !== 'undefined') {
  const writeKey = window.__CHIME_CONFIG__?.segmentWriteKey;
  if (writeKey) {
    withOneTrust(analytics).load({ writeKey });
  }
}
